<template>
    <div>
        <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col">
                            <h3 class="mb-0">
                              Relatórios de Solicitações <span style="font-size: 12px;">(Dentistas x Laboratório)</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                       <div class="text-right p-4">
                         
                       </div>
                      <div class="d-flex column px-3 mb-4">
                        <base-button class="align-self-start" :disabled="aplicandoFiltros" :icon="aplicandoFiltros ? 'fas fa-circle-notch fa-spin' : filtrosAlterados ? 'fas fa-check' : 'fas fa-filter'" size="sm" :type="filtrosAlterados ? 'info' : 'default'" :outline="!filtroAberto && !aplicandoFiltros" @click="aplicarFiltros()">{{filtrosAlterados ? 'Aplicar filtros' : 'Filtros'}}</base-button>
                        <div class="row filtros px-2 mt-3" v-show="filtroAberto">

                            <base-input class="mr-2 flex-grow-2" type="date" placeholder="data" v-model="filtros.data_de"></base-input>
                            <base-input class="mr-2 flex-grow-2" type="date" placeholder="data" v-model="filtros.data_ate"></base-input>

                            <base-input class="mr-2 flex-grow-1" v-if="opcoesFiltros.dentista && user.tipo == 'lab'">
                            <multiselect
                              v-model="filtros.dentista"
                              track-by="valor"
                              label="nome"
                              :options="opcoesFiltros.dentista"
                              placeholder="por dentista"
                              selectLabel="Selecionar"
                              selectedLabel="✔"
                              deselectLabel="Limpar"
                            >
                              <span slot="noResult">Todos os dentistas</span>
                            </multiselect>
                          </base-input>

                        </div>
                        <base-button size="sm" v-if="filtroAberto" class="limpar mt-2 align-self-end clickable small" outline @click="limparFiltros()">Limpar filtros</base-button>
                      </div>

                      <div class="table-responsive">
                        <template>
                          <base-table class="table align-items-center table-flush"
                                      tbody-classes="list"
                                      :data="listaDados">
                            <template slot="columns">
                              <th class="text-center" v-show="user.tipo === 'lab'">
                                <input type="checkbox" v-model="selectAll" @change="toggleAll">
                              </th>
                              <th>#</th>
                              <th>Laboratório</th>
                              <th>Dentista</th>
                              <th>Paciente</th>
                              <th class="text-right">Serviço (R$)</th>
                              <th class="text-right">Pago (R$)</th>
                              <th class="text-right">Pendente (R$)</th>
                              <th class="text-center">Data de Execução</th>
                              <th class="text-center">Pagamento</th>
                            </template>

                            <template slot-scope="{row}">
                              <th class="text-center" v-show="user.tipo === 'lab'">
                                <input type="checkbox" v-model="row.selected" v-show="row.arquivo === false && row.contabilizar == 1" @change="checkIfAllSelected">
                              </th>
                              <th scope="row">
                                <span>{{ row.id }}</span>
                              </th>
                              <td>
                                {{ row.laboratorio.nomeFantasia }}
                              </td>
                              <td>
                                {{ row.dentista.nome }}
                              </td>
                              <td>
                                {{ row.paciente }}, {{ row.idade }}
                              </td>
                              <td class="text-right">
                                R$ {{ row.valores.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                                <td class="text-right">
                                R$ {{ row.valor_pago.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                                <td class="text-right">
                                R$ {{ row.valor_pendente.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                              </td>
                              <th class="text-center">
                               {{ formatarData(row.created_at) }}
                              </th>
                              <td class="text-center">
                              <div class="" v-show="row.contabilizar == 1 && row.valor_pago == 0 && row.valor_pendente > 0">
                                  <i class="fas fa-exclamation-circle" style="color: #F44C00;"></i>
                                </div>
                                <div class="" v-show="row.contabilizar == 1  && row.valor_pago > 0 && row.valor_pendente > 0">
                                  <i class="fas fa-exclamation-circle" style="color: #F2B705;"></i>
                                </div>
                                  <div class="" v-show="row.contabilizar == 1 && row.valor_pago == row.valores">
                                  <i class="fas fa-check-circle" style="color: #5BAD4A;"></i>
                                </div>
                                <div class="" v-show="row.contabilizar == 1 && row.valor_pago == row.valores && row.arquivo !== false">
                                  <a :href="storage_url + '/storage/' + row.arquivo.file" title="Abrir Arquivo" target="_blank"><i class="fas fa-eye"></i></a>
                                </div>
                                <div class="" v-show="row.contabilizar == 0">
                                  <i class="fas fa-not-equal" style="opacity: 0.3"></i>
                                </div>
                              </td>
                            </template>

                          </base-table>
                        </template>
                      </div>

                      <div class="totalFiltered" v-if="totalFiltered > 0">
                        Valor Total: 
                        <span>
                          R$ {{ totalFiltered.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
                        </span>
                      </div>

                       <template v-if="loading">
                          <div class="m-2">
                            <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                          </div>
                        </template>

                        <div slot="footer" class="caseSalvar d-center flex-row p-1 no-print" v-if="!loading">
                          <base-button type="warning" @click="imprimir2()">Imprimir Cupom</base-button>
                          <base-button type="success" @click="pagamento()" v-show="user.tipo === 'lab'">Registar Pagamento</base-button>
                        </div>

                       <div class="card-footer d-flex justify-content-center" v-if="!loading && showMore">
                        <span class="text-size-xl cursor" @click="loadMore()">
                          <i class="fas fa-chevron-circle-down"></i>
                        </span>
                      </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import ordens from '@/cflow/ordens.js'
  import moment from 'moment';
  import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import router from '@/router'
  import config from 'config';
  export default {
    name: 'tables',
    components: {
      Multiselect,
      BaseButton,
      BaseInput
    },
    methods: {
      pagamento() {

        const listData = this.listaDados;
        const selecteds = listData.filter(item => item.selected);

        const firstData = selecteds[0];
        const hasUnsame = selecteds.filter(item => item.dentista.id !== firstData.dentista.id);

        if(selecteds == 0) {
          alert('Por favor, selecione no mínimo uma ordem de serviço.');
          return;
        }

        if(hasUnsame.length > 0) {
          alert('Por favor, selecione um mesmo dentista para armazenar um pagamento.');
          return;
        }

        const idxs = selecteds.map(item => item.id).join('__');
        router.push('/relatorio-solicitacoes/pagamentos/' + idxs);

      },
      imprimir2() {

        var data_de = this.today;
        var data_ate = this.today;

        if(this.filtros.data_de && this.filtros.data_ate) {
          data_de = this.filtros.data_de;
          data_ate = this.filtros.data_ate;
        }

        let dentista = 0;
        if(this.filtros?.dentista?.id)
          dentista = this.filtros.dentista.id;

        ordens.imprimirRelatorio(data_de, data_ate, this.skiped, dentista).then( res => {
        var width = 400;
        var height = 800;
        var left = (screen.width / 2) - (width / 2);
        var top = (screen.height / 2) - (height / 2);
        
        var winBox = window.open('', 'CenteredWindow', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
        winBox.document.write(res);
        winBox.document.close();
      } )
      },
      aplicarFiltros() {
        this.filtroAberto = !this.filtroAberto
        if(this.filtrosAlterados){
          // se os filtros mudaram, então aplicar eles.
          this.aplicandoFiltros = true;
          this.loading = true;

          let dentista = 0;
          if(this.filtros?.dentista?.id)
            dentista = this.filtros.dentista.id;

          ordens.listarRelatorio(this.filtros.data_de, this.filtros.data_ate, this.skiped, dentista).then(res => {
            this.listaDados = res;
            this.aplicandoFiltros = false;
            this.filtrosAlterados = false;
            this.loading = false;

            this.totalFiltered = 0;
            if(dentista !== 0) {
              res.forEach(item => {
                this.totalFiltered += item.valores;
              })
            }
          }).catch(erro => {
            console.err('Ocorreu um erro', erro)
            this.aplicandoFiltros = false;
          })
        }
      },
      limparFiltros() {
        this.filtros = {
          data_de: null,
          data_ate: null
        }
      },
      loadMore: function() {
        this.skiped = this.skiped + this.listaDados.length;
        this.initLoad(this.skiped);
      },
      initLoad: function(skip) {
        this.loading = true;
        var user = storage.get("user");
        //var labId = 0;
        if(user.tipo && user.tipo == 'lab') {
          //labId = user.id;
        }
        Promise.all([ordens.listarRelatorio(this.today, this.today, skip), ordens.listarRelatorio(this.today, this.today, skip, 0, 1)]).then( res => {
          this.listaDados = this.listaDados.concat(res[0]);
          this.loading = false;
          this.showMore = (res[0] == 0) ? false : true;
        
          this.opcoesFiltros.dentista = res[1];
          this.totalFiltered = 0;
        })
      },
       toggleAll() {
          this.listaDados.forEach(item => {
            console.log('item', item)
            item.selected = this.selectAll;
          });
        },
        checkIfAllSelected() {
          this.selectAll = this.listaDados.every(item => item.selected);
        }
    },
    watch: {
      filtros: {
        deep: true,
        handler(){
          this.filtrosAlterados = true
        }
      }
    },
    data() {
      return {
        totalFiltered: 0,
        loading: false,
        skiped: 0,
        user: {},
        listaDados:[],
        filtrosAlterados: false,
        filtroAberto: false,
        aplicandoFiltros: false,
        today: moment().format('YYYY-MM-DD'),
        storage_url: config[process.env.NODE_ENV].api.endpoint,
        filtros: {
          data_de: null,
          data_ate: null,
          dentista: null
        },
        opcoesFiltros: {
          dentista: [],
          paciente: [],
        },
        showMore: true,
        selectAll: false
      }
    },
    mounted(){
      this.user = storage.get("user");
      this.initLoad(0);
    }
  };
</script>
<style lang="scss" scoped>
.filtros .form-group{
  width: 150px;
}
.caseSalvar {
  padding: 30px 0 !important
}
.fas {
  font-size: 16px;
  margin: 0 4px;
}
.totalFiltered {
  padding: 50px 0 20px 0;
  text-align: center;
}
.totalFiltered span {
  display: block;
  width: 100%;
  font-weight: 700;
  font-size: 26px;
}
</style>
